import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DropdownProps } from './Dropdown';

export const Container = styled.div<{
  width: DropdownProps['width'];
}>`
  ${({ width }) => css`
    position: relative;
    width: ${width ? `${width}px` : '100%'};
  `}
`;

export const PlaceHolderWrapper = styled.div<{ type: DropdownProps['type'] }>`
  ${({ theme, type }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: ${type === 'Default' ? '44px' : '32px'};
    padding: 0 0 0 12px;
    border: 1px solid
      ${type === 'Default'
        ? theme.backgroundColor.elevated
        : theme.stroke.stroke_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.elevated};
    cursor: pointer;

    & > button {
      display: block;
      overflow: hidden;
      color: ${theme.themeColor.basic};
      ${theme.fontStyle.text.body16_medium}
    }

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 100%;
      margin-left: 12px;
      border-left: 1px solid
        ${type === 'Default' ? 'none' : theme.stroke.stroke_1};
    }

    &:hover,
    &.on {
      border: 1px solid ${theme.themeColor.main_1};

      & > div {
        border-left: 1px solid
          ${type === 'Default' ? 'none' : theme.themeColor.main_1};
      }
    }
  `}
`;

export const OptionWrapper = styled.div<{ type: DropdownProps['type'] }>`
  position: absolute;
  z-index: 1;
  top: ${({ type }) => (type === 'Default' ? '48px' : '36px')};
  width: 100%;
  overflow: hidden;
`;
